import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import LocationSearchMap from './Map/LocationSearchMap';
import { KEY_CODE_ENTER } from '../lib/constants';

import btnClose from '../images/common/close.svg';

const Main = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;
const Box = styled.div`
  width: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #1f1f2c;
  @media (max-height: 530px) {
    width: 450px;
    height: 300px;
    overflow-y: auto;
  }
`;
const Contents = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const Header = styled.div`
  height: 50px;
  background-color: #43528a;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  padding: 0 10px;
  @media (max-height: 530px) {
    height: 30px;
    font-size: 14px;
  }
`;
const Body = styled.div`
  padding: 0px 50px;
  @media (max-height: 530px) {
    padding: 0px 10px;
  }
`;
const SearchArea = styled.div`
  display: ${props => (props.hidden ? 'none' : 'flex')};
  flex-direction: row;
  align-items: center;
  padding-top: 30px;
  @media (max-height: 530px) {
    padding-top: 10px;
  }
`;
const MapArea = styled.div`
  width: 500px;
  height: 400px;
  margin: 20px 0px;
  @media (max-height: 530px) {
    width: 90%;
    height: 100px;
    margin: 10px 0px;
  }
`;
const Submit = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0px;
  @media (max-height: 530px) {
    margin: 10px 0px;
  }
`;
const CloseButton = styled.div`
  margin: 20px 18px 20px 18px;
  @media (max-height: 530px) {
    margin: 0px;
  }
`;
const CloseButtonImage = styled.img`
  width: 20px;
  height: 20px;
  @media (max-height: 530px) {
    width: 16px;
    height: 16px;
  }
`;
const SearchBox = styled.input`
  width: 300px;
  height: 36px;
  padding: 5px;
  font-size: 15px;
  @media (max-height: 530px) {
    height: 26px;
  }
`;
const LatLngArea = styled.div``;
const SearchButton = styled.div`
  margin-left: 20px;
  width: 100px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1f1f2c;
  background-color: #fff;
  border: 1px #cacaca solid;
  border-radius: 5px;
  font-size: 15px;
  @media (max-height: 530px) {
    width: 80px;
    height: 26px;
    font-size: 13px;
  }
`;
const SetButton = styled.div`
  color: #1f1f2c;
  background-color: #fff;
  border: 1px ##cacaca solid;
  width: 150px;
  height: 50px;
  display: ${props => (props.hidden ? 'none' : 'flex')};
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-size: 15px;
  @media (max-height: 530px) {
    width: 100px;
    height: 30px;
  }
`;

const LocationSearch = ({
  locationSearchData,
  onChangeAddress,
  onSearchMap,
  onClickMap,
  onUpdateMap,
  onCloseMap,
  readOnly,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const placeholderAddress = formatMessage({
    id: 'map.SearchLatLng.placeholder.address',
  });
  const displayLatLng =
    formatMessage({ id: 'map.SearchLatLng.title.lat' }) +
    locationSearchData.lat +
    formatMessage({ id: 'map.SearchLatLng.title.lng' }) +
    locationSearchData.lng;
  return (
    <Main
      id="LocationSearchClose"
      role="presentation"
      onClick={() => onCloseMap()}
    >
      <Box role="presentation" onClick={e => e.stopPropagation()}>
        <Contents>
          <Header>
            <FormattedMessage id="map.SearchLatLng.title" />
            <CloseButton
              id="LocationSearchCloseButton"
              role="presentation"
              className="button"
              onClick={() => onCloseMap()}
            >
              <CloseButtonImage src={btnClose} alt="close" />
            </CloseButton>
          </Header>
          <Body>
            <SearchArea hidden={readOnly}>
              <SearchBox
                id="LocationSearchAddressInput"
                type="text"
                placeholder={placeholderAddress}
                value={locationSearchData.address || ''}
                onChange={e => {
                  onChangeAddress({ address: e.target.value });
                }}
                onKeyDown={e => {
                  const isEnter = e.keyCode === KEY_CODE_ENTER;
                  if (isEnter && locationSearchData.address) {
                    onSearchMap(locationSearchData.address);
                  }
                }}
              />
              <SearchButton
                id="LocationSearchSearch"
                role="presentation"
                className="button"
                onClick={() => {
                  if (locationSearchData.address) {
                    onSearchMap(locationSearchData.address);
                  }
                }}
              >
                <FormattedMessage id="map.SearchLatLng.button.search" />
              </SearchButton>
            </SearchArea>
            <MapArea>
              <LocationSearchMap
                locationSearchData={locationSearchData}
                onClickMap={onClickMap}
              />
            </MapArea>
            <LatLngArea>{displayLatLng}</LatLngArea>
            <Submit>
              <SetButton
                hidden={readOnly}
                id="LocationSearchSet"
                role="presentation"
                className="button"
                onClick={() => {
                  const params = {
                    lat: locationSearchData.lat,
                    lng: locationSearchData.lng,
                  };
                  onUpdateMap(params);
                }}
              >
                <FormattedMessage id="map.SearchLatLng.button.set" />
              </SetButton>
            </Submit>
          </Body>
        </Contents>
      </Box>
    </Main>
  );
};

LocationSearch.propTypes = {
  locationSearchData: PropTypes.object.isRequired,
  onChangeAddress: PropTypes.func.isRequired,
  onSearchMap: PropTypes.func.isRequired,
  onClickMap: PropTypes.func.isRequired,
  onUpdateMap: PropTypes.func.isRequired,
  onCloseMap: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

LocationSearch.defaultProps = {
  readOnly: false,
};

const mapStateToProps = state => ({
  locationSearchData: state.position.locationSearchData,
});
export default connect(mapStateToProps)(LocationSearch);
